<div>
  <form [formGroup]="openingHoursForm" class="forms-sample">
    <div class="form-group d-flex flex-column w-100">
      <label for="openTime">
        {{'SETTINGS.OPENING_HOURS.OPEN_TIME' | translate}}
      </label>
      <p-calendar inputId="openTime" formControlName="openTime" [timeOnly]="true" />
    </div>

    <div class="form-group">
      <label for="closeTime">
        {{'SETTINGS.OPENING_HOURS.CLOSE_TIME' | translate}}
      </label>
      <p-calendar inputId="closeTime" formControlName="closeTime" [timeOnly]="true" />
    </div>

    <div class="form-group">
      <p-checkbox formControlName="closeIsOnSameDay" inputId="closeIsOnSameDay" [binary]="true"></p-checkbox>
      <label class="form-check-label mb-0 ms-2 align-middle" for="closeIsOnSameDay">
        {{'SETTINGS.OPENING_HOURS.CLOSE_IS_ON_SAME_DAY' | translate}}
      </label>
    </div>
  </form>
</div>
